import * as React from 'react'

import { ActionGroup, ActionMenu } from '@/components/base/action-menu'
import { Heading } from '@/components/base/heading'
import { clx } from '@/utils/clx'

/**
 * This component is based on the `div` element and supports all of its props
 */
export const Container = React.forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<'div'>>(
	({ className, ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={clx('w-full rounded-lg bg-ui-bg-base shadow-elevation-card-rest', className)}
				{...props}
			/>
		)
	}
)
Container.displayName = 'Container'

export const ContainerHeader = ({
	heading,
	subHeading,
	actions,
	rightSide
}: {
	heading: React.ReactNode
	subHeading?: React.ReactNode
	rightSide?: React.ReactNode
	actions?: ActionGroup[]
}) => {
	return (
		<div className='flex w-full items-center justify-between gap-3 px-3 py-2 sm:px-6 sm:py-4'>
			<div className='min-w-0 shrink-0'>
				{typeof heading === 'string' ? <Heading>{heading}</Heading> : heading}
				{subHeading && subHeading}
			</div>
			<div className='flex items-center gap-x-2'>
				{rightSide && rightSide}
				{actions && actions.length > 0 && <ActionMenu groups={actions} />}
			</div>
		</div>
	)
}
